const progressActive = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0M5.543 4.527 6.617 3.47l4.438 4.492-4.52 4.566-1.07-1.05L8.94 7.96z" clip-rule="evenodd"/></svg>',
};

export { progressActive as default };
